import { getTheme, styled } from '~/utils';

// Colors
const secondaryDark = getTheme('secondary.dark');
const primaryDark = getTheme('primary.dark');
const primaryMain = getTheme('primary.main');
const secondaryContrast = getTheme('secondary.contrast');

// Spacing
const smallSpacing = getTheme('smallSpacing');
const mediumSpacing = getTheme('mediumSpacing');
const largeSpacing = getTheme('largeSpacing');

// Radius
const smallRadius = getTheme('smallRadius');


// Breakpoints
const inMobileAndTablet = getTheme('inMobileAndTablet');

export const IconContainer = styled.div<{ isOpened: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  transform: ${({ isOpened }) => isOpened && 'rotate(180deg)'};
  transition: transform 0.2s ease-in-out;
`;

export const Content = styled.div`
  width: 100%;
`;

export const DropDownTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${secondaryContrast};
  font-size: 14px;
`;

export const DropDownHeader = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: ${secondaryDark};
  border: 1px solid ${primaryDark};
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    border-color: ${({ disabled }) => !disabled && primaryMain};
  }
`;

export const Text = styled.span`
  color: ${secondaryContrast};
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ScrollBar = styled.div<{ items?: boolean }>`
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${primaryDark};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${primaryMain};
  }
`;